







import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'ParallaxContainer',
  props: {
    factor: {
      default: 0.25,
      type: Number,
    },
  },
  data() {
    return {
        height: 0,
        scrollFactor: 0,
        width: 0,
        backgroundPosition:0
    };
  },
  mounted() {
    this.calcParallax();

    // We're using a `requestAnimationFrame()`
    // for optimal performance.
    const eventHandler = () => requestAnimationFrame(this.calcParallax);
    window.addEventListener('resize', eventHandler);
    window.addEventListener('scroll', eventHandler);
    // Remove the scroll hanlder when the
    // component is destroyed.
    this.$on(`hook:destroyed`, () => {
      window.removeEventListener('resize', eventHandler);
      window.removeEventListener('scroll', eventHandler);
    });
  },
  setup(){

  },
  methods: {
    /*getOffset(){
      return (this.scrollFactor as number) * (this.height as number) * this.factor
    },*/
    calcParallax() {
      const containerRect = this.$el.getBoundingClientRect();

      this.height = containerRect.height;
      this.width = containerRect.width;

      const viewportOffsetTop = containerRect.top;
      const viewportOffsetBottom = window.innerHeight - viewportOffsetTop;

      this.scrollFactor = viewportOffsetBottom / (window.innerHeight + this.height);
      this.backgroundPosition = this.scrollFactor * this.height * this.factor;
    }
  },
});
